import {ScreenDetector} from "./ScreenDetector";

export const ScreenDetectorFactory = {
    /**
     * @param {function} mobileViewDetectionCallback
     * @returns {ScreenDetector}
     */
    create(mobileViewDetectionCallback) {
        return new ScreenDetector(mobileViewDetectionCallback);
    }
};